import getRecipientName from 'documents-ui/utils/getRecipientName';
import * as links from 'documents-lib/js/lib/links';
import ContactAvatar from 'documents-ui/components/ContactAvatar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Header } from 'foundations-components/transitional/components/Header';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DetailContactCard = ({
  contact
}) => {
  const renderName = () => {
    const nameNode = getRecipientName(contact);
    if (contact && nameNode) {
      return /*#__PURE__*/_jsx(H3, {
        wordBreak: "break-all",
        children: /*#__PURE__*/_jsx(Link, {
          target: "_blank",
          external: true,
          href: links.getContactProfileURL(Number(contact.get('vid'))),
          children: nameNode
        })
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.recipientsTable.row.someone"
    });
  };
  return /*#__PURE__*/_jsx(Header, {
    title: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "500",
      children: [/*#__PURE__*/_jsx(ContactAvatar, {
        contact: contact,
        size: "md"
      }), renderName()]
    }),
    paddingInlineStart: "400",
    paddingBlockStart: "0"
  });
};
export default DetailContactCard;